import { createContext, useContext, useState } from "react";
import { useUser } from "../hooks/useUser";
import { useEffect } from "react";

export const UserContext = createContext();


export const useUserContext = () => {
    return useContext(UserContext)
}

export const UserProvider = ({ children }) => {

    const [user, setUser] = useState(undefined)

    const { data } = useUser()
    useEffect(() => {
        setUser(data || {})
    }, [data])

    return (
        <UserContext.Provider value={{ user, setUser }}>{children}</UserContext.Provider>
    )
}